var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-example",class:[..._vm.className]},[_c('p',[_vm._v("Example view")])])
}
var staticRenderFns = []

export { render, staticRenderFns }